import api from "@/store/api";

const cliente = {
  namespaced: true,
  state: () => ({
    data: {},
    status: 0,
  }),
  mutations: {
    setData: (state, payload) => (state.data = payload),
  },
  actions: {
    getData({ commit }, { idCliente, callbackSuccess, callbackError }) {
      commit("setStatus", 1);
      api
        .get(`api/customer/${btoa("customer_" + idCliente)}`)
        .then((result) => {
          commit("setData", result.data.content);
          commit("setStatus", !result.data.content ? 3 : 0);
          callbackSuccess && callbackSuccess(result);
        })
        .catch((err) => {
          console.error(err);
          callbackError && callbackError(err);
          commit("setStatus", 2);
        });
    },
  },
};

export default cliente;
